document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('enquiry-modal');
    // const openButton = document.getElementById('product-enquiry-open');
    const closeButton = document.getElementById('modal-close');
    const modalOverlay = modal?.querySelector('.modal-overlay');

    function openModal(sku) {
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        const skuField = document.querySelector('[data-fui-id="productEnquiry-sku"]');
        console.log(skuField, sku);
        skuField.value = sku;
    }

    function closeModal() {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
    }

    document.querySelectorAll('.product-enquiry-open').forEach(button => {
        button.addEventListener('click', function() {
            const sku = this.getAttribute('data-sku');
            openModal(sku);
        });
    });
    closeButton?.addEventListener('click', closeModal);
    modalOverlay?.addEventListener('click', closeModal);

    // Optional: Close modal on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
            closeModal();
        }
    });
});
